const columns = [
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a?.name?.localeCompare(b?.name),
  },
  {
    title: "Rule Type",
    dataIndex: "ruleTypeName",
    sorter: (a, b) => a?.ruleTypeName?.localeCompare(b?.ruleTypeName),
  },
  {
    title: "Level",
    dataIndex: "ruleLevel",
    sorter: (a, b) => a?.ruleLevel?.localeCompare(b?.ruleLevel),
  },
  {
    title: 'Maximum',
    dataIndex: 'max',
    sorter: (a, b) => a.max - b.max,
  },
  {
    title: 'Minimum',
    dataIndex: 'min',
    sorter: (a, b) => a.min - b.min,
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: (a, b) => a?.description?.localeCompare(b?.description),
  },
];

export default columns;
